import { VerificationInfoModal } from '@/entities/verification/ui';
import { useModalStore } from '@/shared/lib';
import { cn } from '@/shared/utils';

interface Props {
  title?: string;
  onBack?: () => void;
  dialogClassName?: string;
}

export function useVerificationInfoModal() {
  const { showDialogComponent, closeDialog } = useModalStore();

  const openVerificationInfoModal = (props?: Props) => {
    showDialogComponent({
      component: (
        <VerificationInfoModal title={props?.title} onBack={props?.onBack} />
      ),
      className: cn(
        'sm:max-w-[48rem] max-h-[36.4rem] overflow-y-auto border-0 flex',
        props?.dialogClassName || ''
      ),
      onClose: closeDialog,
    });
  };

  return { openVerificationInfoModal };
}
